import { Injectable } from '@angular/core';
import { BehaviorSubject, distinctUntilChanged, map, Observable } from 'rxjs';
import { CartBillService } from 'src/app/shared/services';

@Injectable()
export class PaymentMethodItemService {
    private creditCardItem: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
    private echeckItem: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
    private showCardForm: BehaviorSubject<boolean | null> = new BehaviorSubject<boolean | null>(null);
    private showEcheckForm: BehaviorSubject<boolean | null> = new BehaviorSubject<boolean | null>(null);

    constructor(private cartBillService: CartBillService) {}

    get instant_credit_item_selected(): string | null {
        return this.creditCardItem.value;
    }

    setCreditCardItem(paymentMethod: string): void {
        this.creditCardItem.next(paymentMethod);
    }

    getCreditCardItemSelected$(): Observable<string | null> {
        return this.creditCardItem.asObservable().pipe(distinctUntilChanged());
    }

    setShowCardForm(status: boolean): void {
        this.showCardForm.next(status);
    }

    getShowCardFormSelected$(): Observable<boolean | null> {
        return this.showCardForm.asObservable().pipe(distinctUntilChanged());
    }

    get instant_echeck_selected(): string | null {
        return this.echeckItem.value;
    }

    setEcheckItem(paymentMethod: string | null): void {
        this.echeckItem.next(paymentMethod);
    }

    getEcheckItemSelected$(): Observable<string | null> {
        return this.echeckItem.asObservable().pipe(distinctUntilChanged());
    }

    setShowEcheckForm(status: boolean): void {
        this.showEcheckForm.next(status);
    }

    getShowEcheckFormSelected$(): Observable<boolean | null> {
        return this.showEcheckForm.asObservable().pipe(distinctUntilChanged());
    }

    isEnoughCredit(creditAmount: number): Observable<boolean> {
        return this.cartBillService.getSubTotalCart$().pipe(
            map((subTotal: number) => {
                if (creditAmount < subTotal || !creditAmount) {
                    return false;
                }
                return true;
            })
        );
    }
}
